import React from "react";
import "./project.scss";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { projects } from "../Constants/Constant";
import { BsLink45Deg } from "react-icons/bs";
import { BiUnlink } from "react-icons/bi";

const Project = () => {
  return (
    <div className="project-main" id="portfolio">
      <div className="main-title">Portfolio</div>
      <div className="projects">
        {projects.map((p, index) => {
          return (
            <AnimationOnScroll animateIn="animate__swing" key={index}>
              <div className="project" key={index}>
                <header>
                  <img
                    src={p.image}
                    alt="project-img"
                    className="image-hover"
                    onMouseOver={(e) => (e.currentTarget.src = p.image2)}
                    onMouseOut={(e) => (e.currentTarget.src = p.image)}
                  />
                </header>
                <div className="body-container">
                  <div className="body">
                    <div className="title-header">
                      <h3 className="main-subtitle">{p.title}</h3>
                      <a
                        className="visit"
                        href={p.visit}
                        target={p.visit ? "_blank" : ""}
                        rel="noreferrer"
                      >
                        {p.visit ? (
                          <BsLink45Deg size="2rem" />
                        ) : (
                          <BiUnlink size="2rem" />
                        )}
                      </a>
                    </div>
                    <p>{p.description}</p>
                  </div>
                  <footer>
                    <ul className="tech-list">
                      {p.tags.map((tag, i) => {
                        return <li key={i}>{tag}</li>;
                      })}
                    </ul>
                  </footer>
                </div>
              </div>
            </AnimationOnScroll>
          );
        })}
      </div>
    </div>
  );
};

export default Project;
